module.exports = __webpack_public_path__ + "static/media/star-full.feff49cc.svg";